import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { Link } from 'react-router-dom'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

interface BreadcrumbItem {
  label: string
  path?: string
}

interface PageHeaderProps {
  title: string
  description?: string
  breadcrumbs?: BreadcrumbItem[]
  badge?: string
  badgeColor?: 'primary' | 'secondary' | 'success' | 'warning' | 'error'
}

export default function PageHeader({
  title,
  description,
  breadcrumbs,
  badge,
  badgeColor = 'primary',
}: PageHeaderProps) {
  return (
    <Box sx={{ mb: 4 }}>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          sx={{ mb: 2 }}
        >
          {breadcrumbs.map((item, index) =>
            item.path ? (
              <Link
                key={index}
                to={item.path}
                style={{
                  color: '#64748B',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                }}
              >
                {item.label}
              </Link>
            ) : (
              <Typography
                key={index}
                color="text.primary"
                sx={{ fontSize: '0.875rem' }}
              >
                {item.label}
              </Typography>
            )
          )}
        </Breadcrumbs>
      )}

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
        <Typography variant="h1" sx={{ fontSize: '2rem' }}>
          {title}
        </Typography>
        {badge && (
          <Chip
            label={badge}
            size="small"
            color={badgeColor}
            sx={{ fontWeight: 500 }}
          />
        )}
      </Box>

      {description && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ fontSize: '1.1rem', lineHeight: 1.6 }}
        >
          {description}
        </Typography>
      )}
    </Box>
  )
}
